import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { Button as Button$1 } from '../../Button/Button.js';
import '@mui/material';
import 'react';
import '../../Listbox/ListBox.js';

function Button(_a) {
    var { children, component } = _a, rest = __rest(_a, ["children", "component"]);
    return (jsx(Button$1, Object.assign({}, rest, { color: "grey", component: component, variant: "outlined", children: children })));
}

export { Button };
//# sourceMappingURL=Button.js.map
